var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.021 8.87994L13.5536 20.438L22.8 8.87994H17.021Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97892 8.87994H1.19988L10.4463 20.438L6.97892 8.87994Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5876 7.60592L17.9843 3.00256C17.8656 2.88389 17.7047 2.81723 17.5368 2.81723H15.1928L16.9886 7.60592H22.5876Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01114 7.60592L8.80687 2.81723H6.46291C6.29508 2.81723 6.1341 2.88389 6.01542 3.00256L1.41212 7.60592H7.01114Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6911 8.87994H8.30936L12.0002 21.1829L15.6911 8.87994Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3721 7.60592H15.6278L13.832 2.81723H10.1679L8.3721 7.60592Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond_icon.dfeca4ba0eaff7e25089ef4bc30627c5.svg";
export { ForwardRef as ReactComponent };